import { WSService } from "../../../../utils/WSService";

export const insuranceCoverageService = new WSService("/v2/insurance/coverage");
